import * as sessionReplay from '@amplitude/session-replay-browser';
import { useEffect } from 'react';

import { sessionReplayState } from './sessionReplayState.ts';

// Stops Amplitude session replay when any sport onboarding completes
export const useSessionReplayShutdown = (isOnboarded: boolean) => {
  useEffect(() => {
    if (!sessionReplayState.active) return;
    if (isOnboarded) {
      sessionReplay.shutdown();
      sessionReplayState.active = false;
    }
  }, [isOnboarded]);
};
